<template>
  <!-- sticky kontejner -->
  <aw-drop
    tag="table"
    :list="list"
    list-item-key="url"
    class="Table Table--Sticky Table--Stripped bg-white rounded-md shadow mb-8"
    @drop-item="dropItem"
  >
    <template #header>
      <tr class="TableHeader">
        <th class="py-3.5 px-3"></th>
        <th class="py-3.5 pr-3 pl-5 text-left">{{$t('Name')}}</th>
        <!--
        <th class="py-3.5 px-3 whitespace-nowrap">Added</th>
        <th class="py-3.5 px-3 whitespace-nowrap">Last change</th>
        -->
        <th class="py-3.5 px-3 whitespace-nowrap">
          <span v-if="showPublishedDate">
            {{$t('Published')}}
          </span>
        </th>
        <th class="py-3.5 px-3 whitespace-nowrap" v-if="trash">
          {{$t('Deleted')}}
        </th>
        <th class="py-3.5 px-3 text-right whitespace-nowrap">{{$t('Actions')}}</th>
      </tr>
    </template>
    <template #default="{ item, index }">
      <folder-table-row :item="item" :key="item.url" :draggable="!disableDraggable" :trash="trash" :rank="index" />
    </template>
    <template #footer>
      <tr v-if="loading">
        <td class="py-3.5 px-3" :colspan="trash?5:4">Loading</td>
      </tr>
    </template>
  </aw-drop>
</template>

<script>
import { mapStores } from 'pinia'
import bcFolderStore from '@/frontapp/store/bcFolder'
import FolderList from '../../mixins/FolderList'

export default {
  mixins: [FolderList],
  props: {
    list: Array,
    loading: {
      type: Boolean,
      default: false,
    },
    showPublishedDate: {
      type: Boolean,
      default: false,
    },
    trash: {
      type: Boolean,
      default: false
    }
  },
  computed: {
   ...mapStores(bcFolderStore),
    parentBcFolderId() {
      return this.bcFolderStore.current.id
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .Table--Sticky {
    @apply static;
  }
  .Table {
    tr:first-child {
      @apply hidden;
    }
  }
}
</style>
